function showArtDetail(artnr, catalogpartner) {
    document.artdetail.target = "";
    document.artdetail.showartdetailnr.value = artnr;
    document.artdetail.catalogpartnerid.value = catalogpartner;
    document.artdetail.submit();
}

function showArtDetailSearchString(artnr, catalogpartner, searchstring) {
    document.artdetail.target = "";
    document.artdetail.showartdetailnr.value = artnr;
    document.artdetail.catalogpartnerid.value = catalogpartner;
    document.artdetail.searchstring.value = searchstring;
    document.artdetail.submit();
}

function showArtDetail3(artnr, catalogpartner) {
    document.artdetail.target = "";
    document.artdetail.showartdetailnr.value = artnr;
    document.artdetail.catalogpartnerid.value = catalogpartner;
    document.artdetail.reloadedForStock.value = "Y";
    document.artdetail.submit();
    replaceOnLoadGIF();
}
function showArtDetail2(artnr, catalogpartner) {
    document.artdetail.target = "";
    document.artdetail.showartdetailnr.value = artnr;
    document.artdetail.catalogpartnerid.value = catalogpartner;
    document.artdetail.displaymenu.value = 'quicksearch';
    document.artdetail.submit();
}
function editFreetextArticle(editfreetextcartarticleid, mode, catalogpartner_id) {
    document.artdetail.target = "";
    document.artdetail.catalogpartnerid.value = catalogpartner_id;
    document.artdetail.editfreetextcartarticleid.value = editfreetextcartarticleid;
    document.artdetail.editfreetextmode.value = mode;
    if (catalogpartner_id != '') {
        document.artdetail.displaymenu.value = 'freetext_' + catalogpartner_id;
    } else {
        document.artdetail.displaymenu.value = 'freetext';
    }
    document.artdetail.submit();
}
function convertFreetextArticle(convertfreetextcartarticleid, overrideprice) {
    document.convertfreetextarticle.convertfreetextcartarticleid.value = convertfreetextcartarticleid;
    if (overrideprice) {
        document.convertfreetextarticle.overrideprice.value = "Y";
    }
    document.convertfreetextarticle.submit();
}
function editContinuingObligationArticle(editfreetextcartarticleid, mode, catalogpartner_id) {
    document.artdetail.target = "";
    document.artdetail.catalogpartnerid.value = catalogpartner_id;
    document.artdetail.editfreetextcartarticleid.value = editfreetextcartarticleid;
    document.artdetail.editfreetextmode.value = mode;
    if (catalogpartner_id != '') {
        document.artdetail.displaymenu.value = 'freetext_dienstleistungsbeschaffung_' + catalogpartner_id;
    } else {
        document.artdetail.displaymenu.value = 'freetext_dienstleistungsbeschaffung';
    }
    document.artdetail.submit();
}
function editFreetextArticle2(editfreetextcartarticleid, mode, catalogpartner_id, seller_edit_enabled) {
    document.artdetail.target = "";
    document.artdetail.catalogpartnerid.value = catalogpartner_id;
    document.artdetail.editfreetextcartarticleid.value = editfreetextcartarticleid;
    document.artdetail.editfreetextmode.value = mode;
    document.artdetail.editfreetextsellerenabled.value = seller_edit_enabled;
    if (catalogpartner_id != '') {
        document.artdetail.displaymenu.value = 'freetext_' + catalogpartner_id;
    } else {
        document.artdetail.displaymenu.value = 'freetext';
    }
    document.artdetail.submit();
}
function showConfigArtDetail(artnr, mode, catalogpartner) {
    document.artdetail.target = "";
    document.artdetail.showartdetailnr.value = artnr;
    document.artdetail.catalogpartnerid.value = catalogpartner;
    document.artdetail.config.value = "Y";
    document.artdetail.showmode.value = mode;
    document.artdetail.submit();
}
function showTreeArtDetail(artnr, mode, catalogpartner) {
    document.artdetail.target = "";
    document.artdetail.showartdetailnr.value = artnr;
    document.artdetail.catalogpartnerid.value = catalogpartner;
    document.artdetail.tree.value = "Y";
    document.artdetail.showmode.value = mode;
    document.artdetail.submit();
}

function checkfreetextarticle(absolute_discount_enabled, comma, selected_cluster_type, cart_status) {
    var retval = '';
    var price_value = '';

    switch (selected_cluster_type)
    {
        case 'corporate_spend_services':
        {
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (cart_status != 'active')
            {
                if (document.editfreetextform.update_freetext_eclass_category.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_eclass_category'] + "\n";
                }
            }
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_service_description'] + "\n";
            }
            if (document.editfreetextform.update_price_currency.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_currency'] + "\n";
            }
            /*
             if(document.editfreetextform.update_freetext_industry.value == '') {
             retval += output['t_bitte_befuellen_sie_das_feld_industry']+"\n";
             }
             */
            if (document.editfreetextform.elements["update_freetext_countries_involved[]"].value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_countries_involved'] + "\n";
            }
            if (document.editfreetextform.update_freetext_contract_end_date.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_contract_end_date'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_order_unit'] + "\n";
            }

            break;
        }
        case 'services':
        {
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (cart_status != 'active')
            {
                if (document.editfreetextform.update_freetext_type_of_service_involved.value == '' || document.editfreetextform.update_freetext_type_of_service_involved.value == 'choose') {
                    retval += output['t_bitte_befuellen_sie_das_feld_type_of_services_involved'] + "\n";
                }
                if (document.editfreetextform.update_freetext_eclass_category.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_eclass_category'] + "\n";
                }
            }
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_service_description'] + "\n";
            }
            if (document.editfreetextform.update_price_currency.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_currency'] + "\n";
            }
            /*
             if(document.editfreetextform.update_freetext_industry.value == '') {
             retval += output['t_bitte_befuellen_sie_das_feld_industry']+"\n";
             }
             */
            if (document.editfreetextform.elements["update_freetext_countries_involved[]"].value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_countries_involved'] + "\n";
            }
            if (document.editfreetextform.update_freetext_contract_end_date.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_contract_end_date'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_order_unit'] + "\n";
            }

            break;
        }
        case 'hardware':
        {
            if (document.editfreetextform.update_description_short.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_kurztext'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_mengeneinheit'] + "\n";
            }
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }

            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (cart_status != 'active')
            {
                /*
                 if(document.editfreetextform.update_freetext_eclass_category.value == '') {
                 retval += output['t_bitte_befuellen_sie_das_feld_eclass_category']+"\n";
                 }*/
                if (document.editfreetextform.update_manufacturer_name.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_manufacturer_name'] + "\n";
                }
                if (document.editfreetextform.update_manufacturer_aid.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_manufacturer_aid'] + "\n";
                }
            }

            break;
        }
        case 'software':
        {
            if (document.editfreetextform.update_description_short.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_kurztext'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_mengeneinheit'] + "\n";
            }
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }

            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (cart_status != 'active')
            {
                /*
                 if(document.editfreetextform.update_freetext_eclass_category.value == '') {
                 retval += output['t_bitte_befuellen_sie_das_feld_eclass_category']+"\n";
                 }*/
                if (document.editfreetextform.update_manufacturer_name.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_manufacturer_name'] + "\n";
                }
                if (document.editfreetextform.update_manufacturer_aid.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_manufacturer_aid'] + "\n";
                }
            }
            break;
        }
        default:
        {
            if (document.editfreetextform.update_description_short.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_kurztext'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_mengeneinheit'] + "\n";
            }
            if (document.getElementsByName('cart_status')[0].value != 'active') {
                if (document.getElementsByName('update_tax')[0].value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_steuersatz'] + "\n";
                }
            }
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }

            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (absolute_discount_enabled == 'Y')
            {
                if ((document.editfreetextform.update_price_amount.value - document.editfreetextform.update_discount_absolute.value) < 0) {
                    retval += output['e_absoluter_rabatt_derf_nicht_weniger_als_null_ergeben'] + "\n";
                }
            }

            break;
        }
    }

    return retval;
}

function checkfreetextarticle2(absolute_discount_enabled, comma, selected_cluster_type, cart_status) {
    var retval = '';

    var replace_val = '';
    var price_value = '';

    if (comma == ',')
        replace_val = '.';
    else
        replace_val = ',';

    switch (selected_cluster_type)
    {
        case 'corporate_spend_services':
        {
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_langtext'] + "\n";
            }
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            /* replace_val replace thousender char, comma replaces decimal char */
            document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(replace_val, '');
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');

            //commented this and added var price_value because in input field ',' (decimal seperator) is allways replace with '.'
            //document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(comma,'.');

            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (cart_status != 'active')
            {
                if (document.editfreetextform.update_freetext_eclass_category.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_eclass_category'] + "\n";
                }
            }
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_service_description'] + "\n";
            }
            if (document.editfreetextform.update_price_currency.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_currency'] + "\n";
            }
            /*
             if(document.editfreetextform.update_freetext_industry.value == '') {
             retval += output['t_bitte_befuellen_sie_das_feld_industry']+"\n";
             }
             */
            /*
             if(document.editfreetextform.elements["update_freetext_countries_involved[]"].value == '') {
             retval += output['t_bitte_befuellen_sie_das_feld_countries_involved']+"\n";
             }
             */
            if (document.editfreetextform.update_freetext_contract_end_date.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_contract_end_date'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_order_unit'] + "\n";
            }

            break;
        }
        case 'services':
        {
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_langtext'] + "\n";
            }
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            /* replace_val replace thousender char, comma replaces decimal char */
            document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(replace_val, '');
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');

            //commented this and added var price_value because in input field ',' (decimal seperator) is allways replace with '.'
            //document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(comma,'.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (cart_status != 'active')
            {
                if (document.editfreetextform.update_freetext_type_of_service_involved.value == '' || document.editfreetextform.update_freetext_type_of_service_involved.value == 'choose') {
                    retval += output['t_bitte_befuellen_sie_das_feld_type_of_services_involved'] + "\n";
                }
                if (document.editfreetextform.update_freetext_eclass_category.value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_eclass_category'] + "\n";
                }
            }
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_service_description'] + "\n";
            }
            if (document.editfreetextform.update_price_currency.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_currency'] + "\n";
            }
            /*
             if(document.editfreetextform.update_freetext_industry.value == '') {
             retval += output['t_bitte_befuellen_sie_das_feld_industry']+"\n";
             }
             */
            if (document.editfreetextform.elements["update_freetext_countries_involved[]"].value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_countries_involved'] + "\n";
            }
            if (document.editfreetextform.update_freetext_contract_end_date.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_contract_end_date'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_order_unit'] + "\n";
            }

            break;
        }
        case 'hardware':
        {
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            /* replace_val replace thousender char, comma replaces decimal char */
            document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(replace_val, '');
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }

            break;
        }
        case 'software':
        {
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            /* replace_val replace thousender char, comma replaces decimal char */
            document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(replace_val, '');
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');
            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }

            break;
        }
        default:
        {
            if (document.editfreetextform.update_description_long.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_langtext'] + "\n";
            }
            if (document.editfreetextform.update_order_unit.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_mengeneinheit'] + "\n";
            }
            if (document.getElementsByName('cart_status')[0].value != 'active') {
                if (document.getElementsByName('update_tax')[0].value == '') {
                    retval += output['t_bitte_befuellen_sie_das_feld_steuersatz'] + "\n";
                }
            }
            document.editfreetextform.update_amount.value = document.editfreetextform.update_amount.value.replace(comma, '.');
            if (isNaN(document.editfreetextform.update_amount.value)) {
                retval += output['t_ungueltige_menge'] + "\n";
            }
            if (document.editfreetextform.update_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_menge'] + "\n";
            }
            /* replace_val replace thousender char, comma replaces decimal char */
            document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(replace_val, '');
            price_value = document.editfreetextform.update_price_amount.value;
            price_value = price_value.replace(comma, '.');

            //commented this and added var price_value because in input field ',' (decimal seperator) is allways replace with '.'
            //document.editfreetextform.update_price_amount.value = document.editfreetextform.update_price_amount.value.replace(comma,'.');

            if (isNaN(price_value)) {
                retval += output['t_ungueltiger_preis'] + "\n";
            }
            if (document.editfreetextform.update_price_amount.value == '') {
                retval += output['t_bitte_befuellen_sie_das_feld_preis'] + "\n";
            }
            if (absolute_discount_enabled == 'Y')
            {
                if ((document.editfreetextform.update_price_amount.value - document.editfreetextform.update_discount_absolute.value) < 0) {
                    retval += output['e_absoluter_rabatt_derf_nicht_weniger_als_null_ergeben'] + "\n";
                }
            }
        }
    }
    return retval;
}
function checkYenComma_old() {
    var value = document.freetextform.new_price_amount.value;
    var len = value.length;
    var pos = 0;

    if (document.freetextform.new_price_currency.value == 'JPY') {
        pos = value.indexOf(',');
        if (pos < 0) {
            pos = value.indexOf('.');
        }
        if (pos >= 0) {
            document.freetextform.new_price_amount.value = value.substring(0, pos);
            alert('Bei JPY sind keine Kommastellen erlaubt.');
        }
    }
}
/**
 * Copies the cartarticle over ajax
 * @param int cartarticleId
 * @returns asyncCall
 */
function copyFreetextArticle(cartarticleId, cartId) {

    var postData = {
        cartarticleId: cartarticleId,
        cartId: cartId
    };
    var className = 'ajax/Freetext/Article/copyCartArticle';
    var progressMessage = output.t_general_message_save_in_progress;
    var okMessage = output.t_general_message_data_saved;
    var failMessage = output.t_general_message_save_failed;
    classicErrrorMessage(progressMessage);

    AjaxHandlerByClass(className, postData, function () {
        classicErrrorMessage(okMessage)
        document.freetextform.addarticle.value = 'N';
        document.freetextform.submit();
    }, function () {
        classicErrrorMessage(failMessage);
    });
}